import { useMutation } from '@tanstack/react-query'

import { QUERY_KEY_CUSTOMER_BY_EMAIL } from '../../types/constants'
import { authenticatedApi } from '../../utils/api'

async function getCustomerByEmail({ email }: { email: string }) {
  return authenticatedApi.get(`customer/by-email?email=${email}`).json<{ exists: string }>()
}

export function useGetCustomerByEmail() {
  return useMutation({
    mutationKey: [QUERY_KEY_CUSTOMER_BY_EMAIL],
    mutationFn: ({ email }: { email: string }) => getCustomerByEmail({ email }),

    retry: false,
  })
}
